// src/handlers/handlers.js

export const handleFormChange = (e, formData, setFormData, setErrors) => {
  const { name, value } = e.target;
  const wholeNumberRegex = /^\d+$/;

  if (
    name === "payout" ||
    name === "payoutRangeMin" ||
    name === "payoutRangeMax" ||
    name === "minEditions" ||
    name === "maxEditions" ||
    // name === "submissionFee" ||
    name === "fundingGoal" // Added fundingGoal here
  ) {
    // Handle numeric value validation and range enforcement for fundingGoal
    let numericValue = parseInt(value.replace(/[^0-9]/g, ""), 10);

    if (name === "fundingGoal") {
      // Enforce range for fundingGoal
      if (isNaN(numericValue)) {
        numericValue = "";
      } else if (numericValue > 1250000) {
        numericValue = 1250000;
      } else if (numericValue < 0) {
        numericValue = 0;
      }
    }

    if (!wholeNumberRegex.test(value) && name !== "fundingGoal") {
      if (typeof setErrors === "function") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Only whole numbers are allowed.",
        }));
      }
      return;
    } else {
      if (typeof setErrors === "function") {
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      }
    }

    if (name === "fundingGoal") {
      // Update fundingGoal separately
      setFormData((prev) => ({
        ...prev,
        fundingGoal: numericValue,
      }));
    } else {
      // Handle other numeric fields
      setFormData((prev) => ({ ...prev, [name]: numericValue }));
    }
  } else {
    // Default case for other input fields
    setFormData((prev) => ({ ...prev, [name]: value }));
  }
};
